import {
  DEFAULT_PCA_LIVE_CHAT_FLAG_VALUE,
  SHOW_PCA_LIVE_CHAT_ICON,
} from '../constants/LaunchDarklyConstants';
import UserManagementStore from '../stores/UserManagementStore';
import { getLaunchDarklyFlag } from '../utils/LaunchDarklyUtils';

class ChatbotWrapper {
  async showPCALiveChatIcon() {
    if (UserManagementStore.isBusinessUser()) return false;
    const flagValue = await getLaunchDarklyFlag(
      SHOW_PCA_LIVE_CHAT_ICON,
      DEFAULT_PCA_LIVE_CHAT_FLAG_VALUE
    );
    return flagValue;
  }
}

export default new ChatbotWrapper();
